import { styled } from '@/stitches.config';

export const Line = styled('hr', {
  all: 'unset',
  position: 'relative',
  display: 'block',
  us: 'none',
  pe: 'none',
  bc: '$primary',
  width: '32px',
  height: '3px',
  my: '$6',
  variants: {
    size: {
      '1': {
        my: '$6',
      },
      '2': {
        my: '$5',
      },
      '3': {
        my: '$4',
      },
      '4': {
        my: '$7',
      },
    },
    variant: {
      white: {
        bc: '$white',
      },
    },
  },
  defaultVariants: {
    size: '1',
  },
});
